// extracted by mini-css-extract-plugin
export default {"autocompletes-container":"ModifyRanking_autocompletes-container__ns-BP"};